/**
 * bpiData.js — Liga BPI (Campeonato Nacional Feminino) — Portugal
 * 2025–26 season — 10 teams. Benfica defending champions (5× consecutive).
 */

export const BPI_SEASON     = '2025–26';
export const BPI_WORKER_URL = 'https://bpi-proxy.footballgirl.workers.dev';

export const BPI_STANDINGS_FALLBACK = [
  { pos:1,  name:'Benfica',              short:'BEN', color:'#CC0000', zone:'champion', p:14, w:13, d:0, l:1,  gf:49, ga:9,  gd:40,  pts:39, form:['W','W','W','W','W'] },
  { pos:2,  name:'Sporting CP',          short:'SCP', color:'#006600', zone:'top',      p:14, w:10, d:1, l:3,  gf:38, ga:14, gd:24,  pts:31, form:['W','W','D','W','W'] },
  { pos:3,  name:'SC Braga',             short:'BRA', color:'#C8102E', zone:'top',      p:14, w:8,  d:2, l:4,  gf:30, ga:18, gd:12,  pts:26, form:['W','L','W','W','D'] },
  { pos:4,  name:'Valadares Gaia',       short:'VGF', color:'#003087', zone:'n',        p:14, w:6,  d:2, l:6,  gf:22, ga:24, gd:-2,  pts:20, form:['L','W','L','W','D'] },
  { pos:5,  name:'Torreense',            short:'TOR', color:'#FF6600', zone:'n',        p:14, w:5,  d:3, l:6,  gf:18, ga:22, gd:-4,  pts:18, form:['L','D','W','D','L'] },
  { pos:6,  name:'Famalicão',            short:'FAM', color:'#800080', zone:'n',        p:14, w:4,  d:3, l:7,  gf:16, ga:26, gd:-10, pts:15, form:['L','W','D','L','W'] },
  { pos:7,  name:'FC Porto',             short:'POR', color:'#003DA5', zone:'n',        p:14, w:4,  d:2, l:8,  gf:15, ga:28, gd:-13, pts:14, form:['L','L','W','D','L'] },
  { pos:8,  name:'Sp. Covilhã',          short:'COV', color:'#006600', zone:'n',        p:14, w:3,  d:3, l:8,  gf:13, ga:29, gd:-16, pts:12, form:['D','L','L','W','L'] },
  { pos:9,  name:'Marítimo',             short:'MAR', color:'#008000', zone:'rel',      p:14, w:2,  d:2, l:10, gf:10, ga:34, gd:-24, pts:8,  form:['L','L','D','L','W'] },
  { pos:10, name:'Clube de Albergaria',  short:'ALB', color:'#FFD700', zone:'rel',      p:14, w:1,  d:2, l:11, gf:8,  ga:35, gd:-27, pts:5,  form:['L','L','L','D','L'] },
];

export const BPI_TOP_SCORERS_FALLBACK = [
  { initials:'CR', name:'Cloé Reveil',      club:'Benfica',       goals:15 },
  { initials:'JS', name:'Jéssica Silva',     club:'Sporting CP',   goals:12 },
  { initials:'AL', name:'Ana Leal',          club:'Benfica',       goals:10 },
  { initials:'DF', name:'Diana Ferreira',    club:'SC Braga',      goals:8  },
  { initials:'NT', name:'Nadège Tonye',      club:'Benfica',       goals:7  },
  { initials:'IS', name:'Inês Santos',       club:'Valadares G.',  goals:5  },
];

export const BPI_FIXTURES_FALLBACK = [
  { date:'2026-04-05', home:'Benfica',       homeColor:'#CC0000', homeGoals:2, awayGoals:0, away:'Torreense',      awayColor:'#FF6600', status:'FT' },
  { date:'2026-04-12', home:'Sporting CP',   homeColor:'#006600', homeGoals:2, awayGoals:0, away:'Valadares Gaia', awayColor:'#003087', status:'FT' },
  { date:'2026-04-12', home:'SC Braga',      homeColor:'#C8102E', homeGoals:3, awayGoals:1, away:'FC Porto',       awayColor:'#003DA5', status:'FT' },
  { date:'2026-04-25', home:'SC Braga',      homeColor:'#C8102E', homeGoals:null, awayGoals:null, away:'Benfica',        awayColor:'#CC0000', status:'NS' },
  { date:'2026-04-25', home:'Valadares G.',  homeColor:'#003087', homeGoals:null, awayGoals:null, away:'Sporting CP',    awayColor:'#006600', status:'NS' },
];

export async function fetchLiveBPIData() {
  if (!BPI_WORKER_URL || BPI_WORKER_URL.includes('footballgirl')) {
    console.info('[BPI] PROXY_URL not set — using fallback data.');
    return null;
  }
  try {
    const r = await fetch(BPI_WORKER_URL, { signal: AbortSignal.timeout(6000) });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const d = await r.json();
    return {
      standings:  d.standings  ?? BPI_STANDINGS_FALLBACK,
      topScorers: d.topScorers ?? BPI_TOP_SCORERS_FALLBACK,
      fixtures:   d.fixtures   ?? BPI_FIXTURES_FALLBACK,
    };
  } catch (e) {
    console.warn('[BPI] Live fetch failed, using fallback:', e.message);
    return null;
  }
}
